export const translations = {
    en: {
        // Common
        loading: "Loading packages...",
        searchPlaceholder: "Search by country names",
        
        // Title Section
        logo: "I love J1",
        subtitle: "Where are you traveling?",
        subtitleDescription: "Add the countries you're traveling to and view the plans that best fit your trip.",
        
        // Sections
        myEsims: "My eSIMs",
        availablePlans: "Available Plans",
        favoritePlans: "Favorite Plans",
        selectDuration: "Select Duration",
        selectDataPackage: "Select Data Package",
        esimFeatures: "Benefits of an eSIM",
        faqTitle: "Frequently Asked Questions",
        
        // eSIM Info
        esimInfoTitle: "What is an eSIM?",
        esimInfoText: "An eSIM is a digital SIM that installs on your phone in seconds and gives you access to a data package without having to change chips or do paperwork. When you arrive in the country, it activates automatically and connects you to the local network without roaming charges, so you can use all your apps as usual.",
        esimInfoNote: "Just keep in mind that not all phones accept eSIM and you won't be able to receive or make traditional calls (WhatsApp works perfectly).",
        
        // Features
        feature1Title: "Activation in 1 minute",
        feature1Description: "Install the eSIM by scanning a QR code or tapping a button. No paperwork or searching for sales points needed.",
        feature2Title: "Connected from landing",
        feature2Description: "The plan activates as soon as you arrive in the country and you already have internet to locate yourself, communicate, and move around without delay.",
        feature3Title: "No need to change your physical chip",
        feature3Description: "You can use your usual chip and keep your WhatsApp number without modifying anything on your phone.",
        feature4Title: "Super low costs",
        feature4Description: "Affordable plans, no contracts or hidden fees. You only pay for what you need during your trip.",
        feature5Title: "5G speed where available",
        feature5Description: "Fast and stable connection to use maps, social networks, video calls, and any app you need.",
        feature6Title: "Instant top-ups",
        feature6Description: "If your plan runs out, you renew it in seconds from the web. No calls or waiting.",
        
        // Cart
        cart: "Cart",
        cartEmpty: "Your cart is empty",
        clearCart: "Clear Cart",
        total: "Total",
        buy: "Pay",
        price: "Price",
        processingFeeIncluded: "Processing Fee (included)",
        quantity: "Quantity",
        subtotal: "Subtotal",
        
        // Package Details
        packageDetails: "Package Details",
        data: "Data",
        dataUsage: "Data Usage",
        duration: "Duration",
        status: "Status",
        speed: "Speed",
        sms: "SMS",
        dataType: "Data Type",
        activeType: "Active Type",
        operators: "Operators",
        supportTopUp: "Allows Top Up",
        countriesIncluded: "Countries Included",
        suspend: "Pause",
        unsuspend: "Activate",
        topup: "Top Up",
        esimSuspended: "eSIM paused successfully",
        esimUnsuspended: "eSIM activated successfully",
        suspendFailed: "The eSIM does not allow to be paused",
        unsuspendFailed: "The eSIM does not allow to be activated",
        noTopupPlansAvailable: "No top-up plans available",
        topupPlans: "Top-up Plans",
        errorLoadingTopupPlans: "Error loading top-up plans",
        packageCodeNotFound: "Package code not found",
        storeNotAvailable: "Store not available",
        viewDetails: "ViewDetails",
        
        // Navigation
        checkCompatibility: "Check Compatibility",
        installation: "How to Install",
        method1Title: "Method 1: Scan QR Code or use the installation button on iOS",
        method1Step1: "Scan the QR Code using your phone's camera or use the installation button on iOS.",
        method1Step2: "Click \"Cellular Plan\" to install.",
        roamingNotice: "Enable roaming for the eSIM. It will not generate any additional charges.",
        method2Title: "Method 2: Enter Activation Code Manually",
        method2Step1: "Go to Settings > Cellular > Add eSIM > Enter Details Manually.",
        method2Step2: "Enter the \"SM-DP+ Address\" and \"Activation Code\", then tap \"Next\".",
        deviceSearchPlaceholder: "Search for your device",
        deviceCompatible: "Compatible",
        deviceNotCompatible: "Not Compatible",
        deviceFound: "Device found",
        deviceNotFound: "Device not found",
        searchYourDevice: "Search for your device to verify eSIM compatibility",
        compatibilityMethod1Title: "Method 1: Use the dialer code",
        compatibilityMethod1Step1: "Open your phone's dialer and type *#06#.",
        compatibilityMethod1Step2: "A screen will display your phone's IMEI.",
        compatibilityMethod1Step3: "If it also shows an \"EID\", your phone supports eSIM.",
        compatibilityMethod2Title: "Method 2: Check through settings",
        compatibilityMethod2Step1: "Go to your phone's settings.",
        compatibilityMethod2Step2: "For iOS: Settings > Mobile Data/Cellular",
        compatibilityMethod2Step3: "For Android: Settings > Connections/SIM card Manager",
        compatibilityMethod2Step4: "Look for an \"Add eSIM\" or \"eSIM\" option.",
        compatibilityMethod3Title: "Method 3: Search in our list",
        
        // Auth
        account: "Account",
        login: "Login",
        register: "Register",
        logout: "Exit",
        createAccount: "Create Account",
        emailAddress: "Email Address",
        password: "Password",
        firstName: "First Name",
        lastName: "Last Name",
        fullName: "Full Name",
        country: "Country",
        language: "Language",
        spanish: "Spanish",
        english: "English",
        passwordMinLength: "Must be at least 6 characters",
        hello: "Hello, {name}!",
        profile: "Profile",
        editProfile: "Edit Profile",
        saveChanges: "Save Changes",
        allRightsReserved: "All rights reserved",
        needHelpContact: "If you need help, contact us at",
        emailCopied: "Email copied to clipboard",
        newPassword: "New Password (optional)",
        profileUpdated: "Profile updated successfully!",
        profileUpdateFailed: "Failed to update profile. Please try again.",
        emailNotVerified: "Your email is not verified. Make sure it's correct and verify it by clicking the link we sent you so you don't lose access to your eSIM information.",
        resendVerificationEmail: "Resend Email",
        verificationEmailResent: "Verification email sent successfully!",
        verificationEmailResendFailed: "Failed to resend verification email. Please try again.",
        verificationCode: "Verification Code",
        sendCode: "Send Code",
        verifyCode: "Verify Code",
        codeSent: "Verification code sent successfully!",
        codeSentMessage: "A code has been sent to your email address",
        emailDetailsMessage: "We will send your eSIM details to this email. Make sure it's correct.",
        codeSendFailed: "Failed to send verification code. Please try again.",
        codeVerificationFailed: "Code verification failed. Please check the code and try again.",
        codeVerified: "Code verified successfully!",
        invalidCode: "Invalid code. Please enter a 6-digit code.",
        nameRequired: "Full name is required.",
        emailRequired: "Email address is required.",
        changeEmail: "Change email",
        
        // Messages
        emailVerified: "Email verified successfully!",
        emailVerificationFailed: "Email verification failed. The link may have expired.",
        loginSuccessful: "Login successful!",
        loginFailed: "Login failed. Please check your credentials.",
        passwordTooShort: "Password must be at least 6 characters",
        registrationSuccessful: "Registration successful!",
        registrationFailed: "Registration failed. Please try again.",
        paymentCanceled: "Payment was canceled. Your cart has been preserved.",
        paymentSuccessful: "Payment successful! Thank you for your purchase. We sent you an email with all the details of your purchase.",
        errorProcessingPayment: "Error processing payment. Please try again.",
        termsAndConditions: "Terms and Conditions",
        pricesInUSD: "Prices in US Dollars (USD)",
        noPlansFound: "No plans found for selected countries",
        noEsims: "No eSIMs found",
        loadingEsims: "Loading your eSIMs",
        usageUpdated: "Usage updated successfully",
        install: "Install",
        qr: "QR",
        iosInstall: "iOS <small>(17.4+)</small>",
        androidInstall: "Android <small>(10+)</small>",
        manual: "Manual",
        scanQrCode: "Scan it with your phone",
        smdpAddress: "SM-DP+ Address",
        activationCode: "Activation Code",
        apn: "APN",
        pin: "PIN",
        puk: "PUK",
        usageDelayNote: "with 1-hour delay",
        
        // Package info
        plan: "plan",
        plans: "plans",
        package: "package",
        packages: "packages",
        day: "day",
        days: "days",
        
        // Status
        included: "Included",
        notIncluded: "Not included",
        yes: "Yes",
        no: "No",
        
        // Data types
        dataInTotal: "Data in Total",
        dailyLimitSpeedReduced: "Daily Limit (Speed Reduced)",
        dailyLimitServiceCutoff: "Daily Limit (Service Cut-off)",
        dailyUnlimited: "Daily Unlimited",
        
        // Active types
        firstInstallation: "First installation",
        firstNetworkConnection: "First network connection",
        
        // Autocomplete
        country: "Country",
        region: "Region",
        global: "Global",
        
        // eSIM fields
        validity: "Validity",
        daysRemaining: "days remaining",
        dayRemaining: "day remaining",
        
        // eSIM Status translations
        GETTING_RESOURCE: "Getting Resource",
        GOT_RESOURCE: "Ready to Install",
        IN_USE: "In Use",
        USED_UP: "Used Up",
        UNUSED_EXPIRED: "Expired",
        USED_EXPIRED: "Expired",
        CANCEL: "Cancelled",
        SUSPENDED: "Suspended",
        REVOKE: "Revoked",
        RELEASED: "Ready to Install",
        DOWNLOAD: "Downloaded",
        INSTALLATION: "Installed",
        ENABLED: "Enabled",
        DISABLED: "Disabled",
        DELETED: "Deleted",
        
        // FAQ
        faqTitle: "Frequently Asked Questions",
        faq1Question: "Can plans be topped up on the same eSIM?",
        faq1Answer: "Users with an installed, active eSIM plan can perform a data top-up to extend both the eSIM validity and data amount. Users can top up an eSIM a maximum of 10 times.",
        faq1AnswerExample: "For example: if you have a 1GB 7 Day European eSIM plan, you could add another 1GB 7 day extension. This top-up would add to the existing plan, making it 2GB for 14 days. ( 1GB + 1GB = 2GB total. 7 Days + 7 Days = 14 Days total )",
        faq1AnswerNote: "Top-ups add validity and data together to give a new, updated total validity and data total after each top-up.",
        faq2Question: "Can a deleted eSIM be reinstalled?",
        faq2Answer: "eSIMs CAN be reinstalled from the same QR code they were installed with, in case they were deleted.",
        faq2AnswerNote: "Users can scan the same QR code used in the initial installation and re-add the eSIM profile in case of eSIM deletion. The reinstall process can only be done with the same device on which it was originally installed.",
        faq2AnswerWarning: "QR codes cannot be shared with another device after they have been deleted.",
        faq3Question: "When does the activation period or validity of a plan begin?",
        faq3Answer: "With the exception of some data plans, most data plans will only begin counting usage once you make your first connection to the local network. This will be indicated as \"Activation Type: First network connection\".",
        faq3AnswerNote: "When showing \"Activation Type: First installation\" the billing period will start immediately after installation and <u>activation</u> on your device. Therefore, we recommend activating the plan only after you have arrived at your destination.",
        faq4Question: "Does my eSIM come with a phone number or SMS?",
        faq4Answer: "Generally, eSIMs are data only. If an eSIM includes a phone number or SMS, it will be detailed in the plan. If there's no mention of minutes or SMS, it's a data-only eSIM.",
        faq5Question: "Can I use a physical SIM and my home number and eSIM together?",
        faq5Answer: "Yes, on dual SIM devices, you can use both a physical SIM with your home number and an eSIM. You can select which SIM to use for cellular data and set the default voice line.",
        faq5AnswerNote: "We suggest turning off your home number data roaming, but turning on Wi-Fi calling. This allows your home number to be accessible anywhere in the world via Wi-Fi or via your eSIM data.",
        faq6Question: "Should I turn on \"Data Roaming\" when using eSIM?",
        faq6Answer: "Yes, turn on data roaming for your eSIM and turn off roaming for your home SIM to avoid additional charges. Go to \"Settings\" > \"Cellular\" > \"Data Roaming\". <b>This is a requirement.</b>",
        faq7Question: "Can I use more than one eSIM provider when traveling abroad?",
        faq7Answer: "Yes, iPhones can store ~10 eSIMs, and Androids can store 5-7 eSIMs. Label eSIMs to avoid confusion.",
        faq8Question: "Can multiple phones scan the same QR code?",
        faq8Answer: "No, each QR code can be scanned by a unique device ID once, and cannot be transferred to another device later.",
        faq9Question: "Does my eSIM support hotspot, tethering or data sharing?",
        faq9Answer: "Yes. All of our eSIMs have enabled hotspot data sharing with other devices as permitted by the device manufacturer. On iOS, APNs are preconfigured except for Japan (set APN to \"vmobile.jp\"). For Android use the eSIM APN password to ensure connectivity. This information is available in the eSIM activation email.",
        faq10Question: "Can I request a refund?",
        faq10Answer: "Yes, refunds can be requested while the QR code has not been used or the service has not been activated.",
        faq10AnswerNote: "Processing fees are not refundable."
    },
    es: {
        // Common
        loading: "Cargando paquetes...",
        searchPlaceholder: "Buscar por nombres de países",
        
        // Title Section
        logo: "I love J1",
        subtitle: "¿A dónde viajas?",
        subtitleDescription: "Agregá los países adonde viajás para ver los planes que mejor se adaptan a tu viaje.",
        
        // Sections
        myEsims: "Mis eSIMs",
        availablePlans: "Planes Disponibles",
        favoritePlans: "Planes Favoritos",
        selectDuration: "Seleccionar Duración",
        selectDataPackage: "Seleccionar Paquete de Datos",
        esimFeatures: "Beneficios de una eSIM",
        faqTitle: "Preguntas Frecuentes",
        
        // eSIM Info
        esimInfoTitle: "¿Qué es una eSIM?",
        esimInfoText: "Una eSIM es una SIM digital que se instala en tu teléfono en segundos y te da acceso a un paquete de datos sin tener que cambiar chips ni hacer trámites. Cuando llegás al país, se activa sola y te conecta a la red local sin cargos de roaming, para que puedas usar todas tus apps como siempre.",
        esimInfoNote: "Solo tené en cuenta que no todos los teléfonos aceptan eSIM y que no vas a poder recibir o hacer llamadas tradicionales (por WhatsApp funciona perfecto).",
        
        // Features
        feature1Title: "Activación en 1 minuto",
        feature1Description: "Instalás la eSIM escaneando un código QR o tocando un botón. No necesitás trámites ni buscar puntos de venta.",
        feature2Title: "Conectado desde que aterrizás",
        feature2Description: "El plan se activa apenas llegás al país y ya tenés internet para ubicarte, comunicarte y moverte sin demora.",
        feature3Title: "No necesitás cambiar tu chip físico",
        feature3Description: "Podés usar tu chip habitual y mantener tu número de WhatsApp sin modificar nada en tu teléfono.",
        feature4Title: "Costos súper bajos",
        feature4Description: "Planes accesibles, sin contratos ni cargos ocultos. Pagás solo lo que necesitás durante tu viaje.",
        feature5Title: "Velocidad 5G donde esté disponible",
        feature5Description: "Conexión rápida y estable para usar mapas, redes, videollamadas y cualquier app que necesites.",
        feature6Title: "Recargas instantáneas",
        feature6Description: "Si se termina tu plan, lo renovás en segundos desde la web. Sin llamadas ni esperas.",
        
        // Cart
        cart: "Carrito",
        cartEmpty: "Tu carrito está vacío",
        clearCart: "Vaciar Carrito",
        total: "Total",
        buy: "Pagar",
        price: "Precio",
        processingFeeIncluded: "Cargo de Procesamiento (incluido)",
        quantity: "Cantidad",
        subtotal: "Subtotal",
        
        // Package Details
        packageDetails: "Detalles del Paquete",
        data: "Datos",
        dataUsage: "Uso de Datos",
        duration: "Duración",
        status: "Estado",
        speed: "Velocidad",
        sms: "SMS",
        dataType: "Tipo de Datos",
        activeType: "Tipo de Activación",
        operators: "Operadores",
        supportTopUp: "Permite Recargar",
        countriesIncluded: "Países Incluidos",
        suspend: "Pausar",
        unsuspend: "Reactivar",
        topup: "Recargar",
        esimSuspended: "eSIM pausada exitosamente",
        esimUnsuspended: "eSIM activada exitosamente",
        suspendFailed: "La eSIM no permite ser pausada",
        unsuspendFailed: "La eSIM no permite ser activada",
        noTopupPlansAvailable: "No hay planes para recarga disponibles",
        topupPlans: "Planes para Recargar",
        errorLoadingTopupPlans: "Error al cargar los planes para recargar",
        packageCodeNotFound: "Código del paquete no encontrado",
        storeNotAvailable: "Tienda no disponible",
        viewDetails: "Ver Detalles",
        
        // Navigation
        checkCompatibility: "Verificar Compatibilidad",
        installation: "Como Instalar",
        method1Title: "Método 1: Escanear Código QR o usa el botón de instalación en iOS",
        method1Step1: "Escaneá el código QR usando la cámara de tu teléfono.",
        method1Step2: "Tocá \"Plan Celular\" para instalar.",
        roamingNotice: "Activá el roaming para la eSIM. No te va a generar ningún gasto adicional.",
        method2Title: "Método 2: Ingresar Código de Activación Manualmente",
        method2Step1: "Andá a Configuración > Celular > Agregar eSIM > Ingresar Detalles Manualmente.",
        method2Step2: "Ingresá la \"Dirección SM-DP+\" y el \"Código de Activación\", luego tocá \"Siguiente\".",
        deviceSearchPlaceholder: "Busca tu dispositivo",
        deviceCompatible: "Compatible",
        deviceNotCompatible: "No Compatible",
        deviceFound: "Dispositivo encontrado",
        deviceNotFound: "Dispositivo no encontrado",
        searchYourDevice: "Busca tu dispositivo para verificar la compatibilidad con eSIM",
        compatibilityMethod1Title: "Método 1: Usar el código del teclado",
        compatibilityMethod1Step1: "Abrí el marcador de tu teléfono y escribí *#06#.",
        compatibilityMethod1Step2: "Se mostrará la pantalla con el IMEI de tu teléfono.",
        compatibilityMethod1Step3: "Si también muestra un \"EID\", tu teléfono es compatible con eSIM.",
        compatibilityMethod2Title: "Método 2: Verificar en configuración",
        compatibilityMethod2Step1: "Andá a la configuración de tu teléfono.",
        compatibilityMethod2Step2: "Para iOS: Configuración > Datos Móviles/Celular",
        compatibilityMethod2Step3: "Para Android: Configuración > Conexiones/Administrador de tarjeta SIM",
        compatibilityMethod2Step4: "Buscá si hay una opción \"Agregar eSIM\" o \"eSIM\".",
        compatibilityMethod3Title: "Método 3: Buscá en nuestra lista",
        
        // Auth
        account: "Cuenta",
        login: "Iniciar Sesión",
        register: "Registrarse",
        logout: "Salir",
        emailAddress: "Dirección de Correo",
        password: "Contraseña",
        firstName: "Nombre",
        lastName: "Apellido",
        fullName: "Nombre Completo",
        country: "País",
        language: "Idioma",
        spanish: "Español",
        english: "Inglés",
        passwordMinLength: "Debe tener al menos 6 caracteres",
        countryPlaceholder: "ej., Estados Unidos",
        hello: "Hola, {name}!",
        profile: "Perfil",
        editProfile: "Editar Perfil",
        saveChanges: "Guardar Cambios",
        allRightsReserved: "Todos los derechos reservados",
        needHelpContact: "Si necesitas ayuda, escribinos a",
        emailCopied: "Email copiado al portapapeles",
        newPassword: "Nueva Contraseña (opcional)",
        profileUpdated: "Perfil actualizado exitosamente!",
        profileUpdateFailed: "Error al actualizar el perfil. Por favor intenta de nuevo.",
        emailNotVerified: "Tu email no está verificado. Asegúrate que es el correcto y verifícalo haciendo click en el link que te enviamos para no perder el acceso a la información de tus eSIMs.",
        resendVerificationEmail: "Reenviar Email",
        verificationEmailResent: "¡Email de verificación enviado exitosamente!",
        verificationEmailResendFailed: "Error al reenviar el email de verificación. Por favor intenta de nuevo.",
        verificationCode: "Código de Verificación",
        sendCode: "Enviar Código",
        verifyCode: "Verificar Código",
        codeSent: "¡Código de verificación enviado exitosamente!",
        codeSentMessage: "Te enviamos un código a tu correo electrónico",
        emailDetailsMessage: "Te vamos a enviar los detalles de tu eSIM a este correo. Asegurate que sea el correcto.",
        codeSendFailed: "Error al enviar el código de verificación. Por favor intenta de nuevo.",
        codeVerificationFailed: "Error al verificar el código. Por favor verifica el código e intenta de nuevo.",
        codeVerified: "¡Código verificado exitosamente!",
        invalidCode: "Código inválido. Por favor ingresa un código de 6 dígitos.",
        nameRequired: "Necesitamos tu nombre completo.",
        emailRequired: "Necesitamos tu dirección de correo.",
        changeEmail: "Cambiar email",
        
        // Messages
        emailVerified: "¡Correo verificado exitosamente!",
        emailVerificationFailed: "La verificación del correo falló. El enlace puede haber expirado.",
        loginSuccessful: "¡Inicio de sesión exitoso!",
        loginFailed: "Error al iniciar sesión. Por favor verifica tus credenciales.",
        passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
        registrationSuccessful: "¡Registro exitoso!",
        registrationFailed: "Error en el registro. Por favor intenta de nuevo.",
        paymentCanceled: "Cancelaste el pago. Tu carrito se mantuvo.",
        paymentSuccessful: "¡Pago exitoso! Gracias por tu compra. Te enviamos un email con todos los detalles de tu compra.",
        errorProcessingPayment: "Error procesando el pago. Por favor intenta de nuevo.",
        termsAndConditions: "Términos y Condiciones",
        pricesInUSD: "Precios en Dólares Estadounidenses (USD)",
        noPlansFound: "No encontramos planes para los países seleccionados",
        noEsims: "No encontramos eSIMs",
        loadingEsims: "Cargando tus eSIMs",
        usageUpdated: "Uso actualizado exitosamente",
        install: "Instalar",
        qr: "QR",
        iosInstall: "iOS <small>(17.4+)</small>",
        androidInstall: "Android <small>(10+)</small>",
        manual: "Manual",
        scanQrCode: "Escanealo con tu celular",
        smdpAddress: "SM-DP+ Address",
        activationCode: "Código de Activación",
        apn: "APN",
        pin: "PIN",
        puk: "PUK",
        usageDelayNote: "con retraso de 1 hora",
        
        // Package info
        plan: "plan",
        plans: "planes",
        package: "paquete",
        packages: "paquetes",
        day: "día",
        days: "días",
        
        // Status
        included: "Incluido",
        notIncluded: "No incluido",
        yes: "Sí",
        no: "No",
        
        // Data types
        dataInTotal: "Datos en Total",
        dailyLimitSpeedReduced: "Límite Diario (Velocidad Reducida)",
        dailyLimitServiceCutoff: "Límite Diario (Corte de Servicio)",
        dailyUnlimited: "Ilimitado Diario",
        
        // Active types
        firstInstallation: "Primera instalación",
        firstNetworkConnection: "Primera conexión de red",
        
        // Autocomplete
        country: "País",
        region: "Región",
        global: "Global",
        
        // eSIM fields
        smdpStatus: "Estado SMDP",
        expiredTime: "Tiempo de Expiración",
        orderUsage: "Uso del Pedido",
        totalVolume: "Volumen Total",
        validity: "Validez",
        daysRemaining: "días restantes",
        dayRemaining: "día restante",
        
        // eSIM Status translations
        GETTING_RESOURCE: "Pendiente",
        GOT_RESOURCE: "Lista para Instalar",
        IN_USE: "En Uso",
        USED_UP: "Agotado",
        UNUSED_EXPIRED: "Vencido",
        USED_EXPIRED: "Vencido",
        CANCEL: "Cancelado",
        SUSPENDED: "Suspendido",
        REVOKE: "Cancelado",
        RELEASED: "Listo para Instalar",
        DOWNLOAD: "Descargado",
        INSTALLATION: "Instalada",
        ENABLED: "Habilitado",
        DISABLED: "Deshabilitado",
        DELETED: "Eliminado",
        
        // FAQ
        faqTitle: "Preguntas Frecuentes",
        faq1Question: "¿Se pueden recargar planes en la misma eSIM?",
        faq1Answer: "Los usuarios con un plan eSIM instalado y activo pueden realizar una recarga de datos para extender tanto la validez de la eSIM como la cantidad de datos. Los usuarios pueden recargar una eSIM un máximo de 10 veces.",
        faq1AnswerExample: "Por ejemplo: si tenés un plan eSIM Europeo de 1GB por 7 días, podrías agregar otra extensión de 1GB por 7 días. Esta recarga se sumaría al plan existente, haciéndolo 2GB por 14 días. ( 1GB + 1GB = 2GB total. 7 Días + 7 Días = 14 Días total )",
        faq1AnswerNote: "Las recargas suman validez y datos para dar un nuevo total de validez y datos actualizado después de cada recarga.",
        faq2Question: "¿Se puede reinstalar una eSIM eliminada?",
        faq2Answer: "Las eSIMs PUEDEN reinstalarse desde el mismo código QR con el que se instalaron, en caso de que hayan sido eliminadas.",
        faq2AnswerNote: "Los usuarios pueden escanear el mismo código QR usado en la instalación inicial y volver a agregar el perfil eSIM en caso de eliminación de la eSIM. El proceso de reinstalación solo se puede hacer con el mismo dispositivo en el que se instaló originalmente.",
        faq2AnswerWarning: "Los códigos QR no se pueden compartir con otro dispositivo después de haber sido eliminados.",
        faq3Question: "¿Cuándo comienza el período de activación o validez de un plan?",
        faq3Answer: "Con la excepción de algunos planes de datos, la mayoría de los planes de datos solo comenzarán a contar el uso una vez que realices tu primera conexión a la red local. Esto se indicará como \"Tipo de Activación: Primera conexión de red\".",
        faq3AnswerNote: "Cuando muestra \"Tipo de Activación: Primera instalación\" el período de facturación comenzará inmediatamente después de la instalación y <u>activación</u> en tu dispositivo. Por lo tanto, te recomendamos activar el plan solo después de haber llegado a tu destino.",
        faq4Question: "¿Mi eSIM viene con un número de teléfono o SMS?",
        faq4Answer: "Generalmente, las eSIMs son solo de datos. Si una eSIM incluye un número de teléfono o SMS, se detallará en el plan. Si no se menciona minutos o SMS, es una eSIM solo de datos.",
        faq5Question: "¿Puedo usar una SIM física y mi número de casa y eSIM juntos?",
        faq5Answer: "Sí, en dispositivos dual SIM, podés usar tanto una SIM física con tu número de casa y una eSIM. Podés seleccionar qué SIM usar para datos celulares y establecer la línea de voz predeterminada.",
        faq5AnswerNote: "Sugerimos desactivar el roaming de datos de tu número de casa, pero activar las llamadas por Wi-Fi. Esto permite que tu número de casa sea accesible en cualquier parte del mundo vía Wi-Fi o vía los datos de tu eSIM.",
        faq6Question: "¿Debo activar \"Roaming de Datos\" al usar eSIM?",
        faq6Answer: "Sí, activá el roaming de datos para tu eSIM y desactivá el roaming para tu SIM de casa para evitar cargos adicionales. Andá a \"Configuración\" > \"Celular\" > \"Roaming de Datos\". <b>Esto es un requisito.</b>",
        faq7Question: "¿Puedo usar más de un proveedor de eSIM cuando viajo al extranjero?",
        faq7Answer: "Sí, los iPhones pueden almacenar ~10 eSIMs, y los Androids pueden almacenar 5-7 eSIMs. Etiquetá las eSIMs para evitar confusión.",
        faq8Question: "¿Pueden varios teléfonos escanear el mismo código QR?",
        faq8Answer: "No, cada código QR puede ser escaneado por un ID de dispositivo único una vez, y no se puede transferir a otro dispositivo después.",
        faq9Question: "¿Mi eSIM admite hotspot, anclaje a red o compartir datos?",
        faq9Answer: "Sí. Todas nuestras eSIMs tienen habilitado el compartir datos de hotspot con otros dispositivos según lo permitido por el fabricante del dispositivo. En iOS, los APN están preconfigurados excepto para Japón (configurá el APN como \"vmobile.jp\"). Para Android usá la contraseña APN de la eSIM para asegurar la conectividad. Esta información está disponible en el email de activación de la eSIM.",
        faq10Question: "¿Se pueden solicitar un reembolso?",
        faq10Answer: "Sí, se pueden solicitar reembolsos mientras el código QR no haya sido utilizado o el servicio no haya sido activado.",
        faq10AnswerNote: "Los cargos de procesamiento no son reembolsables."
    }
};

